<template>
  <div>
    <b-button
      to="/businesses/heros/new"
      variant="primary"
      class="mb-1"
    >
      Create new hero
    </b-button>
    <b-spinner
      v-if="fetchingHeros"
      variant="primary"
    />
    <template v-else>
      <card-collapse
        v-for="hero in heros"
        :key="hero.screen"
        title-class="d-flex justify-content-between align-items-center"
      >
        <template #card-title>
          <div
            class="d-flex justify-content-between align-items-center"
            style="flex:1"
          >
            <h3>Screen {{ hero.screen }}</h3>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              :to="`/businesses/heros/edit/${hero.screen}`"
            >
              <feather-icon
                size="20"
                icon="EditIcon"
              />
            </b-button>
          </div>
        </template>
        <card-collapse
          v-for="(value, key, index) in hero.items"
          :key="index"
          card-classes="mb-0"
          :title="key"
        >
          <b-table
            :fields="tableColumns"
            :items="value"
          >
            <template #cell(image)="data">
              <BAvatar :src="data.item.image" />
            </template>
          </b-table>
        </card-collapse>
      </card-collapse>

    </template>
  </div>
</template>

<script>
import {
  BTable, BButton, BSpinner, BAvatar,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../../store'
import CardCollapse from '@/UI/CardCollapse.vue'

export default {
  components: {
    CardCollapse, BTable, BButton, BSpinner, BAvatar,
  },
  setup(_, ctx) {
    const tableColumns = [
      'image',
      'title',
      'description',
      'address',
      'action',
    ]
    useRegisterStoreModule('business', store)

    const heros = ref([])
    const fetchingHeros = ref(false)
    const fetchHeros = async () => {
      fetchingHeros.value = true
      const result = await ctx.root.$store.dispatch('business/getHeros')
      const { data } = result.data
      heros.value = data
      fetchingHeros.value = false
    }
    fetchHeros()

    return {
      BTable,
      fetchHeros,
      fetchingHeros,
      heros,
      tableColumns,
    }
  },
}
</script>

<style>

</style>
